import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { BehaviorSubject, of } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { HttpUtilService } from "./http-util.service";
import { EnvironmentService } from "./environment.service";

export interface Color {
  $info: string;
  $basic: string;
  $danger: string;
  $primary: string;
  $success: string;
  $warning: string;
  $link_text_color: string;
  $text_control_color: string;
  $text_control_info_color: string;
  $text_control_danger_color: string;
  $text_control_success_color: string;
  $text_control_warning_color: string;
}

@Injectable({
  providedIn: "root",
})
export class ColorsService {
  private _theme = new BehaviorSubject({});
  public theme$ = this._theme.asObservable();
  startLoading: boolean = true;
  isLoading: boolean = true;

  constructor(
    private environmentService: EnvironmentService,
    private http: HttpUtilService
  ) {}

  getTheme$() {
    if (this.startLoading) {
      this.getThemeNetworkCall$().subscribe();
    }
    this.startLoading = false;
    return this.theme$.pipe(
      map((theme: Color) => {
        return { theme, isLoading: this.isLoading };
      })
    );
  }

  getThemeNetworkCall$() {
    return this.http
      .request("get", `${environment.apiRoot}/update-colors`, null, null, true)
      .pipe(
        catchError((error) => of({ error })),
        tap((data: any) => {
          this.isLoading = false;
          if (data?.theme)
            this._theme.next({
              ...data,
              $button_text_color: data?.$button_text_color || "#2c2a2a",
              $heading_text_color: data?.$heading_text_color || "#001b4e",
            } as any);
        })
      );
  }

  updateInstitutionStepAsDone() {
    if (this?.environmentService?._details?.wizard_theme_set) return;
    this.http
      .request(
        "put",
        `${this.environmentService.environment.apiRoot}/institution/fields`,
        {
          wizard_theme_set: true,
        }
      )
      .subscribe();
  }

  updateTheme$(body) {
    return this.http
      .request(
        "post",
        environment.apiRoot + "/update-colors?newTheme=true",
        body,
        null,
        true
      )
      .pipe(catchError((error) => of({ error })))
      .pipe(
        tap((response) => {
          if (response === "SUCCESS") {
            this.updateInstitutionStepAsDone();
            this._theme.next(body.colors);
          }
        })
      );
  }
}
